import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from '../../components/UI/Button';

import styles from './AddAccount.module.css';
import { CurrencyEnum } from '../../types/enums';
import { addAsset } from '../../store/actions/assetsActions';
import { addDebt } from '../../store/actions/debtsActions';

interface AddAccountProps {
  onSubmit?: Function;
}

interface NewAccountFormData {
  name: string;
  value: number;
  type: 'Asset' | 'Debt';
  currency: CurrencyEnum;
}

const defaultValues = {
  name: undefined,
  value: undefined,
  type: undefined,
  currency: undefined,
};

const AddAccount: React.FC<AddAccountProps> = ({ onSubmit }) => {
  const { register, handleSubmit } = useForm<NewAccountFormData>({
    defaultValues,
  });
  const dispatch = useDispatch();

  const submit = ({ name, value, type, currency }: NewAccountFormData) => {
    if (type === 'Asset') {
      dispatch(addAsset(name, value, currency));
    } else if (type === 'Debt') {
      dispatch(addDebt(name, value, currency));
    }
  };

  return (
    <form
      className={styles.container}
      onSubmit={handleSubmit((data) => {
        submit(data);
        onSubmit && onSubmit();
      })}
    >
      <h2>Add account</h2>
      <input
        name="name"
        placeholder="Name"
        ref={register}
        className={styles.field}
      />
      <input
        type="number"
        name="value"
        placeholder="Amount"
        ref={register}
        className={styles.field}
      />
      <select name="type" required ref={register} className={styles.field}>
        <option value="" selected disabled hidden>
          Type
        </option>
        <option value="Asset">Asset</option>
        <option value="Debt">Debt</option>
      </select>
      <select name="currency" required ref={register} className={styles.field}>
        <option value="" selected disabled hidden>
          Currency
        </option>
        <option value={CurrencyEnum.USD}>USD</option>
        <option value={CurrencyEnum.EUR}>EUR</option>
        <option value={CurrencyEnum.UAH}>UAH</option>
      </select>
      <Button submit value="Save" className={styles.submit} />
    </form>
  );
};

export default AddAccount;
